import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import TaskIcon from '@mui/icons-material/Task';
import EditIcon from '@material-ui/icons/Edit';
import axios from '../../../../api/axios';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@mui/icons-material/Add';
// import LOGOimg from "./../../../../src/Images/GVClogo.png";
import logo from "./../../../../Images/GVClogo.png";
import PrintIcon from '@mui/icons-material/Print';
import ReactDOMServer from "react-dom/server";
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import LOGONEW from "../../../../Images/mrpl.png";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const URL = "./payment";

function ViewPayment() {
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });


    const navigate = useNavigate();

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [memberID, setMembetID] = useState('');

    const loadBase64Image = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // Prevents CORS issues if the image is hosted externally
            img.src = url;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                resolve(dataURL);
            };
            img.onerror = (error) => reject(error);
        });
    };


    const columns = [
        { field: 'slNo', headerName: 'ID', width: 200 },
        { field: "retirementPerson", headerName: "Retirement Name", width: 200 },
        { field: "paymentType", headerName: "Payment Mode", width: 200 },
        { field: "memberid", headerName: "Member ID", width: 200 },
        { field: "membername", headerName: "Member Name", width: 200 },
        { field: "age", headerName: "Age", width: 200 },
        { field: "amount", headerName: "Amount", width: 200 },
        { field: "type", headerName: "Type", width: 200 },
        { field: "remarks", headerName: "Remarks", width: 200 },
        { field: "status", headerName: "Status", width: 200 },
        { field: "date", headerName: "Date", width: 200 },        

        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 250,
            cellClassName: 'actions',
            getActions: (params) => {
                return [
                    // <EditData selectedRow={params.row}/>,
                    // <DeleteData selectedRow={params.row} />,                        
                    // <Block selectedRow={params.row} />
                    <EditData selectedRow={params.row} />,
                    <PrintData selectedRow={params.row} />
                    // <DeleteData selectedRow={params.row} />
                ];
            }
        },
    ];



    const [dataList, setDataList] = useState(''); // Initialize with dummy data
    const [editData, setEditData] = useState([]);
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const response = await axios.get(URL);

            if (response.data.status === 401) {
                setDataList(""); // Keep dummy data in case of unauthorized response
            } else {
                const responseData = response.data.message;
                const dataWithIndex = response.data.message.map((item, index) => ({
                    ...item,
                    slNo: index + 1, // Assign sequential SL No starting from 1
                })) || "";
                setDataList(dataWithIndex);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setDataList('');
        }
    };

    const EditData = (props) => {
        return (
            <EditIcon style={{ cursor: "pointer" }} onClick={(e) => {
                e.stopPropagation();
                // setEditData(props.selectedRow);
                navigate('/AddPayment', { state: { action: "update", data: props.selectedRow } });
                //    console.log("data", props.selectedRow);
            }} />
        );
    };

    // const DeleteData = (props) => {
    //     return (
    //         <DeleteIcon style={{ cursor: "pointer" }}
    //             onClick={() => {
    //                 const data = { id: props.selectedRow.id };
    //                 const mainURL = URL + '/' + data.id + '/delete';
    //                 serviceMethod(mainURL, data, handleSuccess, handleException);
    //             }}
    //         />
    //     );
    // };
    const convertImageToBase64 = async () => {
        // Make sure the image path is relative to the public folder
        const response = await fetch(`${process.env.PUBLIC_URL}/mrpl.png`);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(blob);
        });
    };

    const toBase64 = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // To handle cross-origin issues
            img.src = url;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            img.onerror = (err) => reject(new Error(`Failed to load image: ${url}`));
        });
    };

    const generatePdf = async (data) => {

        // Render the PDFPrint component as static HTMLzz
        const logoBase64 = await toBase64(LOGONEW);


        // Create the PDF document definition using the converted content
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [20, 20, 20, 20],
            content: [
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: 'MRPL-ONGC KARMACHARI SANGHA (R)', border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 18
                                },
                            ],

                        ]
                    }
                },
                // First Table
                {
                    table: {
                        widths: ['25%', '75%'], // Set the width for each column
                        body: [
                            [
                                {
                                    image: logoBase64, // Use the 'image' key for the logo
                                    rowSpan: 4,
                                    fit: [75, 75], // Adjust size as needed
                                    border: [false, false, false, false]
                                },
                                {
                                    text: `Affiliated to: MRPL Employee's Union (R.) and Petroleum & Gas Workers Federation of India.`,
                                    border: [false, false, false, false], fontSize: 7
                                }
                            ],
                            ['', { text: `REGD. No. TUA 495/2007`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `Near Cargo Gate, Opp. Oval Outlet, Bajpe Road Katipalla, Mangalore - 575030.`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `PH: 94807 66036      Email:mrplkarmacharisangha495@yahoo.com && moks.mrpl@gmail.com`, border: [false, false, false, false], bold: true, fontSize: 7 }],
                        ]
                    }
                },
                { text: '\n' }, // Add spacing between the tables
                {
                    table: {
                        widths: ['20%', '60%', '20%'], // Adjust the column widths for this table
                        body: [
                            [{
                                text: `NO: ${data.slNo.toString().padStart(4, '0')}`, border: [false, false, false, false], bold: true,
                                alignment: 'center', fontSize: 7
                            },
                            {
                                text: 'OLD AGE FUND RECEIPT', border: [false, false, false, false], bold: true,
                                alignment: 'center', fontSize: 10
                            },
                            {
                                text: '', border: [false, false, false, false], bold: true,
                                alignment: 'center', fontSize: 7
                            },

                            ],

                        ]
                    }
                },
                {
                    table: {
                        widths: ['50%', '50%'], // Adjust the column widths for this table
                        body: [

                            [
                                { text: `Paid By: ${data.memberid} ${data.membername}`, border: [true, true, true, true], fontSize: 10 },
                                { text: `Date:${data.date.split("T")[0].split("-").reverse().join("-")}`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `AGE: ${data.age}`, border: [true, true, true, true], fontSize: 10 },
                                { text: `Retirement Person: ${data.retirementPerson}`, border: [true, true, true, true], fontSize: 10 }
                            ],
                            [
                                { text: `Towards Membership Fees/Donation RS:  ${data.amount}`, border: [true, true, true, true], fontSize: 10 },
                                {
                                    text: `${data.remarks}`, border: [true, true, true, true], bold: true,
                                    alignment: 'Left', fontSize: 10
                                },
                            ],

                        ]
                    }
                },

                { text: '\n' }, // Add spacing between the tables
                {
                    table: {
                        widths: ['20%', '60%', '20%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: `RS.  ${data.amount}`, border: [true, true, true, true], bold: true, fontSize: 18,
                                    alignment: 'center'
                                },
                                {
                                    text: '', border: [false, false, false, false], bold: true,
                                    alignment: 'center'
                                },
                                {
                                    text: 'MOKS', border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 10
                                },

                            ],

                        ]
                    }
                },
                { text: '\n' }, // Add spacing between the tables
                // {
                //     table: {
                //         widths: ['100%'], // Adjust the column widths for this table
                //         body: [
                //             [
                //                 {
                //                     text: `${data.remarks}`, border: [false, false, false, false], bold: true,
                //                     alignment: 'Left',fontSize: 10 
                //                 },
                //             ],

                //         ]
                //     }
                // },
            ]
        };

        // Generate the PDF and open it in a new tab
        pdfMake.createPdf(docDefinition).open();
    };

    const PrintData = (props) => {
        return (
            <PrintIcon
                style={{ cursor: "pointer" }} onClick={(e) => {
                    // e.stopPropagation();              
                    // navigate('/PDFGen', { state: { type: "update", data: props.selectedRow } });
                    generatePdf(props.selectedRow);
                }} />

        );
    };



    let filteredRows = dataList;
    // Filter by VIN
    if (memberID) {
        filteredRows = filteredRows.filter((row) =>
            row.memberid?.toLowerCase().includes(memberID.toLowerCase())
        );
    }



    const handleSubmit = (e) => {
        navigate('/AddPayment', { state: { action: "add", value: "" } });
        // const method = "POST";
        // const data = { oldPassword: currentPassword, newPassword, email: user_email };
        // const mainURL = URL;
        // serviceMethod(mainURL, method, data, handleSuccess, handleException);
    }

    return (
        <div style={{ marginTop: "100px", padding: "0px" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 0 }}>

                <Box sx={{ flexGrow: 1, padding: '10px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField
                                label="Search by Member ID"
                                variant="outlined"
                                value={memberID}
                                onChange={(e) => setMembetID(e.target.value)}  // Update search input
                                sx={{ marginBottom: 2 }}  // Add some spacing below the input
                                fullWidth  // Make it full width
                            />

                        </Grid>
                        <Grid item xs={6} />

                        <Grid item xs={2}>
                            <Button color="inherit"
                                onClick={(e) => handleSubmit(e)}
                                sx={{
                                    backgroundColor: '#0d2365',
                                    color: 'white',  // Change background color to purple
                                    '&:hover': {
                                        backgroundColor: '#0d2365',  // Darken the color on hover
                                    },
                                    borderRadius: '10px'
                                }}

                                startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}>
                                Add Payment
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Stack spacing={3}>
                    <Stack direction="row" spacing={3}>



                        <div>
                            {/* <Button startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />} variant="contained" onClick={toggleDrawer("right", true)}>
                                Add
                            </Button> */}
                        </div>
                    </Stack>
                </Stack>

                {/* <Customer  toggleDrawer={toggleDrawer} state={state}  /> */}
                <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    components={{
                        Toolbar: () => (
                            <Box
                                sx={{
                                    padding: 2,
                                    display: 'flex',
                                    justifyContent: 'flex-start', // Aligns to the left
                                    borderBottom: '0.2px solid grey',  // Adds bottom border
                                }}
                            >
                                <Typography variant="h6"
                                    sx={{
                                        fontWeight: 'medium',
                                        // fontSize: '16px', // Use fontSize instead of font
                                        color: 'darknavy',
                                        fontFamily: 'Montserrat, sans-serif' // Ensure proper font family syntax
                                    }}>
                                    Payments
                                </Typography>
                            </Box>
                        ),
                    }}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: 'darknavy', // Set column header text color to dark navy blue
                            fontWeight: 'bold', // Make column header text bold
                        },
                    }}
                />
            </Box>

        </div>
    );
}

export default ViewPayment;
